import { Link, useMatch, useResolvedPath } from "react-router-dom"
import "./Navbar.css"

export default function Navbar() {
  return (
    <nav className="nav">
      <Link to="/" className="site-title">
        Georgia Leet Math
      </Link>
      <div className="nav-links-container">
      <ul>
        <CustomLink to="/About" className="gmas-linkab">About</CustomLink>
        <CustomLink to="/Test" className="gmas-link">GMAS Math Test</CustomLink>
        <CustomLink to="/NumberOper">Numbers/Operations Practice</CustomLink>
        <CustomLink to="/Geometry">Geometry Practice</CustomLink>
        <CustomLink to="/Algebra">Algebra Practice</CustomLink>
        <CustomLink to="/DataProb">Data/Probability Practice</CustomLink>
      </ul></div>
    </nav>
  )
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end: true })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  )
}